// extracted by mini-css-extract-plugin
export default {"topDrugsBlock":"darkStorePage_topDrugsBlock__hnZJC","card":"darkStorePage_card__+3CJ2","divider":"darkStorePage_divider__ngOgV"};